(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairBoothTableBookedController', VirtualFairBoothTableBookedController);
        VirtualFairBoothTableBookedController.$inject = ['$uibModal', 'ExpoService', 'VirtualFairService'];
    function VirtualFairBoothTableBookedController($uibModal, ExpoService, VirtualFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expos                 = [];
        vm.expoSelected          = -1;
        vm.semesterSelected      = -1;
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.selectSemester        = selectSemester;
        vm.semester              = [];
        vm.getByFilter           = getByFilter;
        vm.getByFilterCSV        = getByFilterCSV;
        vm.orderBy               = orderBy;
        vm.query                 = {};

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function activate() {
            vm.selectSemester();
        }

        function selectExpoBySemester () {
            let query = {};
            query['semester'] = vm.semesterSelected;
            ExpoService.getExpoVirtualBySemester(query).then(function(response){
                 vm.expo = [];
                 vm.expo = response.data;
                 vm.expo.unshift({id: -1, name: '-- All --'})
                 vm.expoSelected = -1;
            });
        }

        function selectSemester () {
            VirtualFairService.getSemesters().then(function(response){
                vm.semester = response.data;
            });
        }

        function getByFilter(reset = false) {
            if(reset) {
                vm.query = {};
            }
            vm.flag = false;
            // let query = {};
            if (vm.expoSelected !== -1) {
                vm.query['expo_id'] = vm.expoSelected;
            }
            if (vm.semesterSelected !== -1) {
                vm.query['semester'] = vm.semesterSelected;
            }
            if (vm.page !== null) {
                vm.query['page'] = vm.page;
            }
            VirtualFairService.getByFilterBoothTableBooked(vm.query).then(function(response){
                vm.expos = response.data.data;
                vm.flag = true;
                if(vm.expos.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function getByFilterCSV(reset = false) {
            let query = {};

            if (vm.expoSelected !== -1) {
                query['expo_id'] = vm.expoSelected;
            }
            if (vm.semesterSelected !== -1) {
                query['semester'] = vm.semesterSelected;
            }

            VirtualFairService.getByFilterBoothTableBookedCSV(query).success(function(data) {
                var anchor = document.createElement('a');
                var file_name = 'online_table_booked_' + vm.semesterSelected;
                if (vm.expoSelected !== -1) {
                    file_name = file_name + '_' + vm.expoSelected;
                }
                file_name = file_name + '.csv';

                var anchor = document.createElement("a");
                anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
                anchor.target = "_blank";
                anchor.download = file_name;
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                anchor.remove();
                }, 50);
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function orderBy (column) {
            if((typeof vm.query['order'] === 'undefined') || (!vm.query['order'])) {
                vm.query['order'] = 'asc';
            } else {
                if(vm.query['order'] === 'asc') {
                    vm.query['order'] = 'desc';
                } else {
                    vm.query['order'] = 'asc';
                }
            }
            vm.query['orderby'] = column;
            vm.page = 1;
            vm.getByFilter();
        }

        activate();
    }
})();